import { useQuery } from '@tanstack/react-query'
import { fetchMyPartiesWithDetails, partyKeys } from '@/services/parties'

export function useMyPartiesWithDetails() {
  const partiesQuery = useQuery({
    queryKey: partyKeys.myPartiesWithDetails(),
    queryFn: () => fetchMyPartiesWithDetails(),
  })

  return {
    parties: partiesQuery.data,
    isLoading: partiesQuery.isLoading,
    error: partiesQuery.error,
  }
}
